export const iconSuffix = 'icon';
